/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import KImage from '@/types/KImage'

export default class HeroWithImage {
  private json: any
  public readonly uid: string
  public readonly description: string
  public readonly getStartedButtonText: string
  public readonly headingOne: string
  public readonly headingTwo: string
  public readonly image?: KImage

  constructor (json: any) {
    this.json = json
    this.uid = json.uid
    this.description = json.description
    this.getStartedButtonText = json.get_started_button_text
    this.headingOne = json.heading_one
    this.headingTwo = json.heading_two
    if (json.image?.url) {
      this.image = new KImage(json.image.url, json.image.content_type, json.alt_text_image)
    }
  }

  static of (json: any): HeroWithImage {
    return new HeroWithImage(json)
  }

  static empty (): HeroWithImage {
    return new HeroWithImage({
      uid: '',
      description: '',
      get_started_button_text: '',
      heading_one: '',
      heading_two: '',
      image: undefined
    })
  }
}
